// frontend/src/components/SyncLastPriceButton.jsx
import React, { useState, useRef } from "react";
import { useAuth } from "../AuthProvider"; 

export default function SyncLastPriceButton({ className = "" }) {
  const { token } = useAuth() || {};
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (loading) return;
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // reset supaya bisa upload file sama 2x
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLoading(true);

    try {                        // <== DI SINI: pakai {, BUKAN :
      const formData = new FormData();
      formData.append("file", file);

      const headers = {};
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const res = await fetch("/api/stocks/upload-lastprice-json", {
        method: "POST",
        headers,
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Upload Last Price JSON gagal");
      }

      alert(
        `Upload Last Price JSON berhasil.\nRows tersimpan: ${data.rows_saved}`
      );
    } catch (err) {
      console.error(err);
      alert(`Sync Last Price gagal: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className={`w-full py-2 px-3 rounded-lg text-left text-sm
          ${loading ? "bg-slate-700 cursor-wait" : "bg-emerald-700 hover:bg-emerald-600"}
          ${className}`}
      >
        {loading ? "Uploading Last Price..." : "Sync Last Price (Upload .json)"}
      </button>

      {/* input file hidden */}
      <input
        type="file"
        ref={fileInputRef}
        accept="application/json"
        className="hidden"
        onChange={handleFileChange}
      />
    </>
  );
}
